import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import ApplicantReviewStyle from "assets/jss/material-dashboard-react/views/goldRatesStyle.js";
import { useDispatch, useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import { saveLoanApplicantDetails } from "store/reducers/LoanDetail/LoanDetailSlice";
import { Grid } from "@material-ui/core";
import ToastModal from "views/components/ToastModal";
const useStyles = makeStyles(ApplicantReviewStyle);

const PawanTickerReview = ({ loanApplicationId,classes }) => {
  const [record, setRecord] = useState("");
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const { authToken } = useSelector((state) => state.login.authData);
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
const dispatch = useDispatch();
  const getAddress = (addresss) => {
    let address = "";
    if (addresss?.houseNumber !== "") {
      address = address + addresss?.houseNumber;
    }
    if (addresss?.street !== "") {
      if (address !== "") {
        address = address + ", ";
      }
      address = address + addresss?.street;
    }
    if (addresss?.locality !== "") {
      if (address !== "") {
        address = address + ", ";
      }
      address = address + addresss?.locality;
    }
    if (addresss?.postOffice !== "") {
      if (address !== "") {
        address = address + ", ";
      }
      address = address + addresss?.postOffice;
    }
    if (addresss?.villageTownCity !== "") {
      if (address !== "") {
        address = address + ", ";
      }
      address = address + addresss?.villageTownCity;
    }
    if (addresss?.state !== "") {
      if (address !== "") {
        address = address + ", ";
      }
      address = address + addresss?.state;
    }
    if (addresss?.district !== "") {
      if (address !== "") {
        address = address + ", ";
      }
      address = address + addresss?.district;
    }
    if (addresss?.pincode !== "") {
      if (address !== "") {
        address = address + ", ";
      }
      address = address + addresss?.pincode;
    }

    return address;
  };
  const getAddharnumber = (input) => {
    input = input.replace(/^(\d{0,4})(\d{0,3})/, "$1 $2");
    var prefix = input.substr(0, input.length - 4);
    var suffix = input.substr(-4);
    var masked = prefix.replace(/\d/g, "*");
    var a = masked + suffix;
    return a;
  };
//   useEffect(() => {
//     GetApplicantData();
//   }, []);
//   const GetApplicantData = async () => {
//     //PPLICANT_GETDATA
//     const result = await apiHandler({
//       url: endpoint.APPLICANT_GETDATA + loanApplicationId,
//       authToken: authToken,
//     });
//     if (result?.data?.error_code) {
  // toastUpdate("Error", "please Provide correct applicant data", true);

//     } else {
//       console.log(result.data);
//       dispatch(
//         saveLoanApplicantDetails({
//           applicantDetails: result.data,
//         })
//       );
//       setRecord(result.data);
//     }
//   };
useEffect(()=>{
    getPawanTicketDetails();
  },[])
  const getPawanTicketDetails =async()=>{
    const result = await apiHandler({
      url: endpoint.PawanTicket_Detials_get + loanApplicationId,
      authToken: authToken,
    });
    if (result.data) {
      setRecord(result.data);
    }
  }
  const itemView = (label, value) => {
    return (
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <p style={{ marginBottom: 0 }}>
              <b>{label}</b>
            </p>
            <label style={{textTransform:'capitalize'}}>{value}</label>
          </Grid>
    );
  };
  return (
      <Grid container>
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        className={classes.inputFieldContainer}
      >
        <h2 className={classes.header} style={{fontSize:"1.5rem"}}>Pawan Ticket Details</h2>
      </Grid>
      <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
        <Grid container className={classes.inputFieldContainer}>
             {itemView("Loan Account Number", record.loanAccountNumber || "NA")}
            {itemView("Customer Name", record.customerName || "NA")}
            {itemView("Sanction Date", record.sanctionedDate || "NA")}
            {itemView("Ornament Value", record.ornamentValue || "NA")}
            {itemView("Sanctioned Amount", record.sanctionedAmount || "NA")}
            {itemView("Actual Loan Amount", record.actualLoanAmount || "NA")}
            {itemView("Quantity", record.quantity || "NA")}
            {itemView("GrossWeight", record.grossWeight || "NA")}
            {itemView("NetWeight", record.netWeight || "NA")}
            {itemView("Rate Per Gram", record.ratePerGram || "NA")}
            {itemView("Ltv", record.ltv || "NA")}
            {itemView("Total Outstanding", record.totalOutstanding || "NA")}
        </Grid></Grid>
        {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
      </Grid>
  );
};

PawanTickerReview.propTypes = {
  classes: PropTypes.object,
  loanApplicationId: PropTypes.object,
  handlecreateuserSubmit: PropTypes.func,
};

export default PawanTickerReview;
